import React from 'react';
import classNames from 'classnames';
import StatusPill from './status-pill';
import { ProbeStatus } from './types';

export interface HealthTab {
	key: string;
	label: string;
	status?: ProbeStatus;
}

interface Props {
	tabs: HealthTab[];
	active: string;
	onSelect: (key: string) => void;
}

export default function HealthTabs({ tabs, active, onSelect }: Props) {
	return (
		<div className='health-dashboard__tabs' role='tablist'>
			{tabs.map((tab) => (
				<button
					key={tab.key}
					type='button'
					role='tab'
					id={`health-tab-${tab.key}`}
					aria-controls='health-tab-panel'
					aria-selected={tab.key === active}
					className={classNames('health-tab', {
						'health-tab--active': tab.key === active,
					})}
					onClick={() => onSelect(tab.key)}
				>
					{tab.label}
					{/* An unselected tab still has to show something is wrong inside it. */}
					{tab.status && <StatusPill status={tab.status} />}
				</button>
			))}
		</div>
	);
}
